import React from "react";
import { IoIosArrowForward } from "react-icons/io";
import { useSelector, useDispatch } from "react-redux";
import SetElementSidebarReducer, {
  setElement,
} from "../../Redux/SidebarReducer";
import { Link, useLocation } from "react-router-dom";
import { IoLogoWhatsapp } from "react-icons/io";
import { IoShareSocialSharp } from "react-icons/io5";
import { FaTelegram } from "react-icons/fa";
import { TiSocialSkype } from "react-icons/ti";
import { GrSkype } from "react-icons/gr";
const SocialGroupsSidbar = (props) => {
  const { title, show, icon: IconComponent } = props;
  const location = useLocation();

  const elementActive = useSelector((state) => state.Sidebar.elementActive);
  const dispatch = useDispatch();
  const handleClick = () => {
    const value = title === elementActive ? "" : title;
    dispatch(setElement(value));
  };

  const SocialGroupsMenu = [
    {
      link: `/TelegramGroups`,
      name: "Telegram Groups",
      icon: FaTelegram,
    },
    {
      link: `/WhatsappGroups`,
      name: "Whatsapp Groups",
      icon: IoLogoWhatsapp,
    },
    {
      link: `/skypeGroups`,
      name: "Skype Groups",
      icon: GrSkype,
    },
  ];

  return (
    <li className=" ">
      <span
        onClick={handleClick}
        className="pr-0 py-[12px]  pl-[25px]  flex hover:text-primary duration-300 relative  items-center cursor-pointer"
      >
        <IoShareSocialSharp className={"text-[16px] mr-[20px]"} />
        Social Groups
        <IoIosArrowForward
          className={`absolute right-3 duration-300 text-[14px]
        ${elementActive === title ? "rotate-90" : "rotate-0"}    `}
        />
      </span>
      <ul
        className={`text-[15px]  pl-[22px] duration-300 overflow-hidden  ${
          elementActive === title ? "h-[8rem]" : "h-0"
        } `}
      >
        {SocialGroupsMenu.map((item, idx) => {
          return (
            <Link key={idx} to={item?.link} color="inherit" underline="none">
              <li
                className={`pr-0 py-[8px]  pl-[25px] text-center whitespace-nowrap flex justify-start gap-x-3 items-center ${
                  item?.link === location.pathname
                    ? "bg-primary text-darkTextColor hover:text-darkTextColor"
                    : "hover:text-primary"
                }`}
              >
                <item.icon />
                <span className=" duration-100 flex  items-center">
                  {item?.name}
                </span>
              </li>
            </Link>
          );
        })}
      </ul>
    </li>
  );
};

export default SocialGroupsSidbar;
